module.exports = __webpack_public_path__ + "img/baggage.b297b2dc.png";